import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { AlertCircle } from 'lucide-react';

export const AlertModal = ({ isOpen, onClose, title, message, type = 'error' }) => {
  const { darkMode } = useTheme();
  if (!isOpen) return null;

  const colors = {
    error: 'text-red-500',
    warning: 'text-yellow-500',
    info: 'text-blue-500',
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50">
      <div className={`max-w-md w-full mx-4 p-6 rounded-lg shadow-2xl ${darkMode ? 'bg-zinc-800' : 'bg-white'}`}>
        <div className="flex items-start space-x-3">
          <AlertCircle className={`w-6 h-6 flex-shrink-0 ${colors[type]}`} />
          <div className="flex-1">
            <h3 className={`text-lg font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              {title}
            </h3>
            <p className={`text-sm whitespace-pre-line ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              {message}
            </p>
          </div>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  const { darkMode } = useTheme();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50">
      <div className={`max-w-md w-full mx-4 p-6 rounded-lg shadow-2xl ${darkMode ? 'bg-zinc-800' : 'bg-white'}`}>
        <div className="flex items-start space-x-3">
          <AlertCircle className="w-6 h-6 flex-shrink-0 text-yellow-500" />
          <div className="flex-1">
            <h3 className={`text-lg font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              {title}
            </h3>
            <p className={`text-sm whitespace-pre-line ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              {message}
            </p>
          </div>
        </div>
        <div className="mt-6 flex justify-end space-x-2">
          <button
            onClick={onClose}
            className={`px-4 py-2 rounded-lg ${darkMode ? 'bg-zinc-700 hover:bg-zinc-600' : 'bg-gray-200 hover:bg-gray-300'}`}
          >
            Cancelar
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};
